import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OurAppsComponent } from 'src/app/home/about-root/our-apps/our-apps.component';
import { FooterMoreInfoComponent } from 'src/app/home/landing-root/footer-more-info/footer-more-info.component';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { CandidateService } from 'src/app/services/candidate.service';
import { VendorService } from 'src/app/services/vendor.service';

@Component({
  selector: 'app-verify-vendor-email',
  standalone: true,
  imports: [
    HeaderLatestComponent,
    FooterMoreInfoComponent,
    OurAppsComponent,
    ],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './verify-vendor-email.component.html',
  styleUrl: './verify-vendor-email.component.scss'
})
export class VerifyVendorEmailComponent {
  [key: string]: any;
  value!: string;


  statusMessage:''
  successMessage:boolean=false
  constructor
  ( 
    private router:Router, 
    private route: ActivatedRoute,
    private candidateService:CandidateService,
    private vendorService:VendorService
  ) 
  { }


  ngOnInit(): void {
    console.log("ngOnInit works");
    const verifyKey = this.route.snapshot.queryParams['verify_key'];
    console.log("Verify Key:", verifyKey);
    if (verifyKey) {
    this.emailVendorVerification(verifyKey);
    }
  }
  
    
  emailVendorVerification(verifyKey:any) {

    let reqObj = {
      verify_key:verifyKey
    }
    this.successMessage =false
    this.vendorService.emailVendorVerification(reqObj).subscribe((resp:any)=>{
    console.log("Rec profile update success", resp);
    this.statusMessage=resp.supportMessage

    if(resp.statusCode ==200){
        this.successMessage = true
        console.log("HHHHHHH",this.successMessage)
        // this.errorStatus =true;
        // this.errorMsg = resp.supportMessage;
        // this.snackBarSimpleComponent.openSnackBar(resp.supportMessage,"","center","top",3);
        
        // this.router.navigate(['matrimonials/thankyou']);
      }
    });
  }

  goTo(link: any) {
    this.router.navigate([link]);
  }

}
